<template>
  <div>
    <b-card
      no-body
      class="liveinfo-form"
    >
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <v-select
              v-model="query.company"
              :options="codes.giftCompany"
              class="el-def"
              placeholder="기프티콘 업체"
              :reduce="(option) => option.code"
            />
            <b-form-datepicker
              v-model="query.startDate"
              class="el-def"
              placeholder="등록일(From)"
            />
            <label class="ml-25 mr-50">~</label>
            <b-form-datepicker
              v-model="query.endDate"
              class="el-def"
              placeholder="등록일(To)"
            />
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col
            cols="12"
            md="10"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <v-select
              v-model="query.isFailure"
              :options="codes.isFailure"
              class="el-def"
              placeholder="성공여부"
              :reduce="(option) => option.code"
            />
            <v-select
              v-model="query.rewardType"
              :options="codes.giftRewardTraceType"
              class="el-def"
              placeholder="보상 구분"
              :reduce="(option) => option.code"
            />
            <b-form-input
              v-model="query.filterStr"
              placeholder="검색어 입력(휴대전화번호)"
              class="el-def"
              style="width:300px;"
              @keyup.enter="refetchData()"
            />
          </b-col>
          <b-col
            cols="12"
            md="2"
            class="d-flex align-items-center justify-content-end"
          >
            <b-button
              variant="primary"
              class="btn-search mr-50"
              @click.prevent="refetchData()"
            >
              조회
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-card
      no-body
    >
      <div class="m-2">
        <b-row>
          <b-col
            md="6"
            class="d-flex align-items-center justify-content-start"
          >
            <h5 class="mb-0 ml-50">
              발송 리스트 [{{ totalRecords }}] 건
            </h5>
          </b-col>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-end"
          >
            <b-button
              variant="outline-dark"
              class="btn-search"
              @click.prevent="excelDown()"
            >
              <feather-icon
                icon="DownloadIcon"
                class="mr-50"
              />
              <span>다운로드</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
      <b-table
        :no-wrap="true"
        :items="resultTable"
        :fields="tableColumns"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDesc"
        responsive
        selectable
        sticky-header
        select-mode="single"
        class="position-relative"
        style="max-height: 65vh; font-size: 12px"
      >
        <template #cell(id)="data">
          {{ data.value }}
        </template>

        <template #cell(cancelDate)="data">
          <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            "
          >
            <span
              v-if="data.item.isCancel === true"
              class="text-nowrap"
            >
              {{ data.value | $dateFormatter('YYYY-MM-DD') }}
            </span>
            <span
              v-if="data.item.isCancel === true"
              class="text-nowrap"
            >
              {{ data.value | $dateFormatter('HH:mm') }}
            </span>
            <b-button
              v-else
              variant="outline-danger"
              size="sm"
              class="mr-1"
              :class="{'hidden': data.item.isFailure}"
              @click.prevent="confirmModal('cancel', data.item)"
            >
              <span>취소</span>
            </b-button>
          </div>
        </template>

        <template #cell(reOrderDate)="data">
          <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            "
          >
            <span
              v-if="data.item.isReOrder === true"
              class="text-nowrap"
            >
              {{ data.value | $dateFormatter('YYYY-MM-DD') }}
            </span>
            <span
              v-if="data.item.isReOrder === true"
              class="text-nowrap"
            >
              {{ data.value | $dateFormatter('HH:mm') }}
            </span>
            <b-button
              v-else
              variant="outline-primary"
              size="sm"
              class="mr-1"
              :class="{'hidden': !data.item.isFailure}"
              @click.prevent="confirmModal('reorder', data.item)"
            >
              <span>재발송</span>
            </b-button>
          </div>
        </template>
      </b-table>
      <b-pagination
        v-model="currPage"
        :total-rows="totalRecords"
        limit="10"
        per-page="20"
        align="center"
      />
    </b-card>

    <div>
      <b-modal
        v-model="cancelModalVisible"
        title="발송 된 기프티콘을 취소하시겠습니까?"
        no-close-on-esc
        no-close-on-backdrop
        @ok.prevent="cancelOrder()"
      >
        <p class="mt-1">
          기프티콘업체: {{ currentOrder.companyName }}
        </p>
        <p>
          보상구분: {{ currentOrder.rewardTypeName }}
        </p>
        <p>
          상품명: {{ currentOrder.goodsName }}
        </p>
        <p>
          휴대폰번호: {{ currentOrder.phoneNumber }}
        </p>
        <p>
          발송일시: {{ currentOrder.sendDateStr }}
        </p>
        <p
          v-if="failureMessage"
          class="text-danger"
        >
          실패메시지: {{ failureMessage }}
        </p>
      </b-modal>
    </div>
    <div>
      <b-modal
        v-model="reOrderModalVisible"
        title="기프티콘을 다시 발송 하시겠습니까?"
        no-close-on-esc
        no-close-on-backdrop
        @ok.prevent="reOrder()"
      >
        <p class="mt-1">
          기프티콘업체: {{ currentOrder.companyName }}
          <span
            v-if="currentOrder.company === 2"
            class="text-primary"
          >
            (* 카카오 기프티콘의 경우 발송 시점에 성공 여부를 알 수 없습니다. (발송 접수 성공/실패 여부만 확인 가능)
            따라서 성공으로 표시되더라도 3~4초 뒤에 목록을 다시 조회하시어 "실패"로 변경되지 않았는지 확인해 주세요.)
          </span>
        </p>
        <p>
          보상구분: {{ currentOrder.rewardTypeName }}
        </p>
        <p>
          상품명: {{ currentOrder.goodsName }}
        </p>
        <p>
          휴대폰번호: {{ currentOrder.phoneNumber }}
        </p>
        <p>
          발송실패일시: {{ currentOrder.sendDateStr }}
        </p>
        <p
          v-if="failureMessage"
          class="text-danger"
        >
          실패메시지: {{ failureMessage }}
        </p>
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from '@axios'
import { ref, onMounted, watch } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { saveAs } from "file-saver"
import dayjs from 'dayjs'

export default {
  components: {
    vSelect,
  },
  setup() {
    onMounted(() => {
      fetchCodes()
      fetchList()
    })
    const toast = useToast()
    const pushToast = (variant, title) => {
      let icon
      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }
      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }

    const codes = ref({
      isFailure: [
        { label: '성공', code: false },
        { label: '실패', code: true },
      ],
      giftCompany: [],
      giftRewardTraceType: [],
    })
    const cancelModalVisible = ref(false)
    const reOrderModalVisible = ref(false)

    // Query Data
    const query = ref({
      startDate: dayjs().add(-1, 'month').format('YYYY-MM-DD'),
      endDate: dayjs().format('YYYY-MM-DD'),
      company: null,
      rewardType: null,
      isFailure: null,
    })

    const currentOrder = ref({})
    const failureMessage = ref('')

    const giftOrderId = ref(0)
    const sortBy = ref('id')
    const isSortDesc = ref(true)
    const resultTable = ref([])

    const tableColumns = ref([
      {
        key: 'id', label: 'ID', sortable: true, thStyle: { width: '7%' },
      },
      {
        key: 'sendDateStr', label: '발송 일시', sortable: true, thStyle: { width: '10%' },
      },
      {
        key: 'companyName', label: '업체명', sortable: false, thStyle: { width: '6%' },
      },
      {
        key: 'rewardTypeName', label: '보상구분', sortable: false, thStyle: { width: '6%' },
      },
      // {
      //   key: 'contentId', label: '컨텐츠', sortable: false, thStyle: { width: '6%' },
      // },
      {
        key: 'orderNo', label: '주문번호', sortable: false, thStyle: { width: '12%' },
      },
      {
        key: 'goodsName', label: '상품명', sortable: false, thStyle: { width: '12%' },
      },
      {
        key: 'realPrice', label: '가격', sortable: false, thStyle: { width: '6%' },
      },
      {
        key: 'discountPrice', label: '실지불액', sortable: false, thStyle: { width: '6%' },
      },
      {
        key: 'status', label: '상태', sortable: false, thStyle: { width: '5%' },
      },
      {
        key: 'phoneNumber', label: '휴대전화번호', sortable: false, thStyle: { width: '9%' },
      },
      {
        key: 'cancelDate', label: '취소/취소일시', thStyle: { width: '8%', textAlign: 'center' },
      },
      {
        key: 'reOrderDate', label: '재발송', thStyle: { width: '8%', textAlign: 'center' },
      },
    ])

    const fetchCodes = () => {
      axios.get('/fa/gift-order/codes')
        .then(rs => {
          // eslint-disable-next-line no-shadow
          const { giftCompany, giftRewardTraceType } = rs.data
          codes.value.giftCompany = giftCompany
          codes.value.giftRewardTraceType = giftRewardTraceType
        })
        .catch(() => {
          pushToast('danger', '코드 데이터를 불러오는데 실패하였습니다.')
        })
    }

    const currPage = ref(1)
    const totalRecords = ref(0)
    const fetchList = () => {
      axios.post('/fa/gift-order/list', {
        startDate: query.value.startDate,
        endDate: query.value.endDate,
        company: query.value.company,
        rewardType: query.value.rewardType,
        isFailure: query.value.isFailure,
        filterStr: query.value.filterStr,
        sort: {
          predicate: sortBy.value,
          reverse: isSortDesc.value,
        },
        pagination: {
          number: currPage.value,
          count: 20,
        },
      })
        .then(rs => {
          const { items, totalRecord } = rs.data

          resultTable.value = items
          totalRecords.value = totalRecord
        })
        .catch(() => {
          pushToast('danger', '데이터 조회에 실패하였습니다.')
        })
    }

    const confirmModal = (type, item) => {
      currentOrder.value = item
      giftOrderId.value = item.id
      failureMessage.value = ''

      if (type === 'cancel') cancelModalVisible.value = true
      else if (type === 'reorder') reOrderModalVisible.value = true
    }

    const cancelOrder = () => {
      if (!giftOrderId.value) {
        pushToast('warning', '취소할 대상을 선택하세요.')
        return
      }
      axios.patch(`/fa/gift-order/cancel/${giftOrderId.value}`)
        .then(() => {
          pushToast('success', '기프티콘 취소 완료')
          cancelModalVisible.value = false
          fetchList()
        })
        .catch(error => {
          failureMessage.value = error.response.data
          pushToast('warning', '기프티콘 취소 과정에서 오류가 발생하였습니다.\n실패 메시지를 확인해 주세요.')
        })
    }

    const reOrder = () => {
      if (!giftOrderId.value) {
        pushToast('warning', '재발송 대상을 선택하세요.')
        return
      }
      axios.patch(`/fa/gift-order/reorder/${giftOrderId.value}`)
        .then(() => {
          pushToast('success', '기프티콘 발송 완료')
          reOrderModalVisible.value = false
          fetchList()
        })
        .catch(error => {
          failureMessage.value = error.response.data
          pushToast('warning', '기프티콘 발송 과정에서 오류가 발생하였습니다.\n실패 메시지를 확인해 주세요.')
        })
    }

    const refetchData = () => {
      fetchList()
    }

    watch(query.value, () => {
      fetchList()
    })
    watch([currPage], () => {
      fetchList()
    })

    const excelDown = () => {
      axios.post('/fa/gift-order/list-excel', {
        startDate: query.value.startDate,
        endDate: query.value.endDate,
        company: query.value.company,
        rewardType: query.value.rewardType,
        isFailure: query.value.isFailure,
        filterStr: query.value.filterStr,
      }, { responseType: 'blob' })
        .then(rs => {
          const blob = new Blob([rs.data])
          const fileName = '기프티콘발송내역'

          saveAs(blob, `${fileName}.xlsx`)
        })
        .catch(() => {
        })
    }

    return {
      sortBy,
      currPage,
      totalRecords,
      isSortDesc,
      tableColumns,
      fetchCodes,
      toast,
      query,
      codes,
      fetchList,
      excelDown,
      resultTable,
      watch,
      refetchData,
      cancelOrder,
      reOrder,
      giftOrderId,
      cancelModalVisible,
      reOrderModalVisible,
      confirmModal,
      currentOrder,
      failureMessage,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
